// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__rE0at","footer":"Form_footer__2zB8y"};